import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'suite-refunds',
  templateUrl: './refunds.component.html',
  styleUrls: ['./refunds.component.scss']
})
export class RefundsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
